import axios from 'axios'
export const getIconfont = (projectCode) => {
  return new Promise((resolve, reject) => {
    axios.get(`https://web-sdk.oss-cn-shanghai.aliyuncs.com/iconfont/${projectCode}.css`, {
      responseType: 'blob'
    })
      .then(response => {
        const reader = new FileReader()
        reader.onload = () => {
          const text = reader.result
          resolve(text.match(/(?<=\.)(.*?)(?=:)/g))
        }
        reader.readAsText(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
